import { useContext } from "react";
import PropTypes from "prop-types";
import { path, prop } from "ramda";
import { useSelector } from "react-redux";

import { numToCurrency } from "../../helpers/formatters";
import { getServiceBlockCallOutInformation } from "../../selectors";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseCallOut = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const callOutInformation = useSelector(getServiceBlockCallOutInformation);

	if (!callOutInformation || !company) return null;

	const field = prop("field", callOutInformation);
	const preFormatterConversions = prop(
		"preFormatterConversions",
		callOutInformation,
	);
	const isConvertedToCurrency = prop(
		"isConvertedToCurrency",
		preFormatterConversions,
	);
	const formatter = prop("formatter", callOutInformation);
	const contentfulFieldValue = path(["fields", field], company);

	if (!contentfulFieldValue) return null;

	const convertedFieldValue = isConvertedToCurrency
		? numToCurrency(contentfulFieldValue)
		: contentfulFieldValue;
	const callOut = formatter
		? formatter(convertedFieldValue)
		: convertedFieldValue;

	return <span className={className}>{callOut}</span>;
};

BaseCallOut.propTypes = {
	className: PropTypes.string,
};
